import {
	Injectable,
	signal,
	WritableSignal
} from '@angular/core';
import _ from 'lodash';
import {
	Observable,
	of,
	tap
} from 'rxjs';

import {
	Product
} from '../interfaces';
import {
	productImageUrl
} from '../resources';
import vegetablesData from '../data/vegetables.json';
import seaFoodData from '../data/sea-food.json';
import dryFoodData from '../data/dry-food.json';
import fruitData from '../data/fruit.json';
import meatData from '../data/meat.json';
import spiceData from '../data/spice.json';
import { ENVIRONMENT } from '@environments/environment';

@Injectable()
export class ProductService {
	public products: WritableSignal<Product[]>
		= signal([]);

	public getProducts(): Observable<Product[]> {
		return of(
			_.shuffle([
				...vegetablesData,
				...seaFoodData,
				...meatData,
				...dryFoodData,
				...fruitData,
				...spiceData
			] as Product[] ).map(
				(product: Product) => ({
					...product,
					image: productImageUrl(
						product.image,
						ENVIRONMENT.PRODUCT_IMAGE_BASE_URL
					),
				})
			)
		)
		.pipe(
			tap( ( products: Product[] ) => {
				this.products.set( products );
			})
		);
	}
}
